import React from 'react';
import PropTypes from 'prop-types';
import CheckboxStyled from './CheckboxStyled';

class Checkbox extends React.PureComponent {
  render() {
    return (
      <CheckboxStyled toggle={this.props.toggle} style={this.props.style}>
        <input
          type="checkbox"
          id={this.props.id}
          disabled={this.props.disabled}
          onChange={this.props.onChange}
          checked={this.props.checked}
        />
        <label htmlFor={this.props.id}>{this.props.children}</label>
      </CheckboxStyled>
    );
  }
}

Checkbox.defaultProps = {
  children: null,
  toggle: false,
  disabled: false,
  checked: false,
  onChange: () => {},
  style: undefined,
};

Checkbox.propTypes = {
  children: PropTypes.node,
  toggle: PropTypes.bool,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.shape(),
};

export default Checkbox;
